import React, { useState, useRef, useEffect } from "react";

import PlayI from "../../Assets/Images/play.png";
import PauseI from "../../Assets/Images/pause.png";

import "./style.scss";

const Index = ({ cardImg, cardHeading, autoplayVideo, cardText, SchoolVideo }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [headingStyle, setheadingStyle] = useState("");
  const videoRef = useRef(null);

  //
  useEffect(() => {
    // Access the video element using videoRef.current
    const video = videoRef.current;
    // Autoplay the video
    if (autoplayVideo) {
      video.autoplay = true;
    }
  }, []);

  const headingRef = useRef(null);
  const handleButtonClick = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const getHeadingStyle = () => {
    if (headingRef.current) {
      const computedStyles = window.getComputedStyle(headingRef.current);
      setheadingStyle(computedStyles.height);
    }
  };
  useEffect(() => {
    getHeadingStyle();
  }, []);

  return (
    <div className={`blog-card`}>
      <div
        className="card-img"
        style={{
          backgroundImage: `url(${cardImg})`,
          backgroundPosition: `center center`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
      >
        <img
          className="logo-img"
          alt="Image"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJgAAABcCAYAAACSu3yDAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAA70SURBVHgB7V07bBzXFb1vdmlRsgFvigT5OR537rxCZMeptOrsSmQXJwFMwrKBVCYrB4kBDoskNlJIrAJEEkQWDuBKVJWk8ghI4dgyRHXpMgbiT5c1EEs0yZ2Xe9+b7+583tud5c7vACvuZ2Z2dua8+zn3vieAFuq4sL0FL+CjhTI60EINz1u3gMEGPhvADwY9+Nz+O7TIBYMW2ehbPViC20DEisOGY1iFA2sILVLREiwLfcv0yNVP2cJBkl1CkjnQIhEtwdIgyfUBPjNztmxJlgEDWkyib/UVyQViG9qWCNliAi3BxnHBGkBXmVw+iGT3xb4tYmizyChe2H4V/93HwGEZ9LGM+63BUxe/gs/ufggtBFqC+SCNC/g1mBWcvQQ/vATwmX0XWrQEEyByMW5BcRi0JJNoCRYKqEWjFWShyTJFuoCaBRJVe6CHRguyzcwiQ41roLEXEQT9HpzHYelo7DcQGWZDZYzmWTB1ATUEEcpAcn3oiakv4jFcPAbXkjIaKcg2y4LpCagSDA5i5CLQ8yO0ZBwlDXU0UpBtjgWTIuht/MU6MdQePI4JgJ0RP12wLDymTgvPEIm5CvcsGxqAZmSR0wioDLbhY2sDHPswc7vPbRu+P2C4/QDU0ChBtv4Em0ZA5XwTPt5+R3l7Itn3Bg+QOC8BKJK4IYJsvQmmL6AOkSSvILl2QRdf2P+CHw3ex2croC5l1F6QrS/BdAVUKT28jG7RhmnxH3sITw3uYIw1wFffVdyr1oJs/YL8aQTUcRmiCPzYuobHfFNjj1oKsvWyYFLj+is+e1F5H4439nEk1z+sL6FIfGH/TTP4N/Fu/Ay+gxbwS7s2JKuPBZtGQAXYEZniPHFhawMYu6qxR60E2XoIrdMJqNtzJxfh3jZlsDrlpVoJstW3YNMJqOtIrl04TeiXl2ohyFY7BtMXUOmmvYw3TafEUwwow/z2YA99xrN4vs8q7FELQba6BNMVUMlFdeCn8JF1AIvCl1gV+Nx+Xyv4r7ggW02C6QqosmD9cqEyxCzQLy9VVpCtHsH0O1CpYP1K4TLErNAvL1VSkK1OkD9dB+rOqWSKs0A/+K+UIFsNguVP4Z8EyRAfWVbeZm//8b0tPsq/ub/79S/Wo69/+857t/L2cRl/8Ie3fpkfJxLJRlq/rzJaWRfKDn0BlUb2JpJrV2VjPmIDjOcGCpvGCCYyvBwYDK0NQD7BZGx4XqO85GtlpSdZuYVWXQFVipmXTl3jKgqfoDvnaHnVUAlBtrwE053C7xesP16gDFEE7qFbp340NZR+yYJyEowEVIbkUlXnSYY4hy6mLDLErNArL/XEtfrJVimTmfIRjDQuznc19tjDeOt8Zt98FUGWmCyyag3TxYJ6CZf3LBfB9AVUKlivQV2hO3uJ47UrGcnKQzAhoGqQi+IUBRmi8iC96561qhz8E8met3Tag+aKxROMBNTnLQrm1xT3oIL1JS9OaQ5E8K+cYW6Ia0rXdsFYLMF0p/DLgvX5pswpnACRzEUVX2p9eSjFkgWLE1p1BVRZsF4tOlPkI75pGK72SGeueylvG7djFJ94fGLto/J/oFheWrggu5hSkRRQqTRiKm1PffNPILnqlinOAr3y0sJKS6dPMP0O1PIXrBcJ9fLSQjpkGb955ip+cT84CcaHaH4/Fa8M7oCLD8JJ12G/OnRgFpCAqqNxKRasGw+d9TEMzL7/OXuCxG/1enB42IPuiYlFV1O86TJ6/iR+2vNeP2D8xmP38U6qdymAEP4cJKIjiEixEZKQvXGcX6J5UTPgPAVl/u1337vtKvz+37/182eir3/z7l/+nbcP49we78KYG3SurcJ1FQQ6/pqm0vUlceBp4PhXhjUmqACTsq4muSD4As5CB2sw4DfO0DMimYNW6gHS14buEwdsfRjGTSUs5XDOeoxxEzSBv9jM3cjQP+7UmOHa8j8tm/DYaIAn/JyXOPRh9AhJZVD8K+8zB31w6BWdRfbFg7EVgM4WniQRzyOde5eCdSVL12JuEJZp9HCA9+iiDI14X7g0PhfFqncaMoVHOmOFRgK6ZLRozAbXvQOjjj1zXNciE4JQJ//rg9G5LNbMGD3qC5MUWKT55nlEMAfUm/kKAKMAcAXNLz44WTiK54hwe+z1ExtazAzh8rojHNDGZbRWOLg7valc3KyQMZiIm0wAv2rPycIk6E2UGTBfWjChOFA8t4YXYY3fMGj5pH28GHfYlSO1Am8LAX69O8BBi26PwhNye77Lm5uFcibfinGErKTTZVe+WYUpIUZKZ9QTI4S5PeHTGX0BfxqCbINpqOSMjrGGT9Zay5YP4f7ch2/iNVsRydrUVoqMiq8OgJSpSKLiaGhIphp1hMHRCWcEN5aXhzPFYOEXHvtvTVgdGQMcymCSCdI9J0dYLvEilq1DScIOnHT2mx6zSVJ9vYJB+asYTw00LZSDR0CPxVBecg+wEnAAS487sUw/EcegC3mfDudfi/RO3vYeAfifl/pSoGMDfHUxRy4xMZ64Ckv8Kr/52G4TrZqUElwk1UOsahgKXoHL687ZXaFZds7ZyUQawjwREEz8APHOiRl8yvCHMB7+GF/VD3ZCE0rmE01h/iiIw5Mr6CGsXmDpGEdzT1YupcMiatVcdxuPsws1hoitWIeWSRgI7TF9Sxm/onoOJwwt/TdO/PMjmPocfG74iHLE54CHcQ8jzhjjHd3/9SINDsghMQyUfjGS0CzjiehoYIFeQ/EFaTbpiYUgGpr6fV2SlxkhsTLvi00JEYYPtva1pTLPktsXBiRU6smYmCDWmB0L2PWxT/E9E+xc4rlljwLhgAwmscTkfirIN674J4BfXx6gCV3LIBslBbtgnNupMtH4zaU1jK+IWGbCp5ThH2D8tAdG/oAKBymnGiGq9CIM6cFpyVKds9+iWiRlILdh8cALx6mu+SBP8c8hWyVdZ47FsvNIFSr04BGJJhPPZIEKAEcLdv3MBp5UaXq4Q3ijlbt3sgjHby7jiOe0Tthg7KNKEC2DWBRW3IHu8rUkUgXZpKwfUtxqQtnguuslJtgEpC5GMUdCRiTVa9eatGpoFY+N1bLJG57FweuOSUsclPlts9cP7Yl9QjF1AMXEzPMF59vM8/m5C3mUEEKEHa9nypF9iDoRj8cxzL2GLma7DPEZJlVv4r9W6MLQWnNjJ8laSVJRHZGvLd7l6YLPGuRPlJVMWAxQ6uB74+Ulz31GibZQtym1P4O8xcB7J5FY1SZVBK57XsoU11G8ZPBkUCYg0hguPicFfRTqHJp6V5AOE7reTTZGJriGTIODJjaREvdhdkg3emRsx6zaONFktrl5mtZMWi1/pZ1JYkkd8Os1UaAuzv054DeHcvYVXoOhKAER6N4STiZrirFrN66B+aVBsaHbC2QOKhEy/mTkfgLKFOdPvyc/A4HYSiTkRj+saU5BPiLRmOI/RjQHjtmlecdmnoegEGSQSixZT9yYzlphjCkkH69+SOUfNAhliTlLRbA0xOqZsqb5nAbpZMHcc4syGcCCOuOyh51xi712pDqhVQv8xjJmtxj7CeLwfUw2Nv0bL7NHrCdOBvlpR5NZNcADUUc8qkYvXSUIlgTl0lIIcvfrvkXzLAvFQ7T/PoqC60W6TG8yzYb8XrbuZ4Xye13KHldyjhCWfjSV+jJhKoKlzighUFyVB3/WkriIjDolhqKmpVTZzzgnldISuc5IjBZxm1CEy4y5RJQbfHcoXeGjLY90SXt6uh/KMKKWWI+ukUyCeaOtf7qlBnGhHfAnj+jMWooehTI2ZqAbIhE2wZ2SbHHU2aEbGdPQXHd1WmvhkYvqukMhMnrHmZQlYr91D6/rPhLxoAwSStGIEUzclA7GBcFkgNKlyLKcNOJ36bkqESSBOM0JoEzOjHwUky349bMoOo/Qmhkb7MrhHmjAaz/6gAiD2dOGPJ5Q6ckNRwgekipJTNWF/G2eJ3Fx8BvG0yKLk4XriDHQKV7H5CdH/EuZKL1H9WPf6yjMlY0TTMgV7FWoDhwAUTRXnkAS1jHhcnDBI24ztELMUiWZp2/dwpu6GcRaYQzmA9/nO+l9WRnHnyxa03kTaU0oB2igS48Dhh0dOGMEq0zZKA2Oapt1guLv+O4RIyi8oWcsvDz380jmWa4tP0P0COqtGZGu0GeeF80CIrfOjItQLiLlw8WE5o3DXf9lnGDl6awoAupkixbMI7IFWjuLJIG0CSgyzuus4Ii1xOtAlqAXasSamFam838BlA9DzMafif7mOMHkyP0v1A+JCv84hPtkeBWYu89eO94M3kO1e3w/aamMPrvyUHbk3lzGDNHdwCrFZnQEJ35PTLUvZaw7HTDUwMEZWyphIosssLu1rIgJr0mQFs29HBVGJ7ZBggVSx40z14TMkmGx5lQKKheO2TOJLdNRSLfg6UL1hiOEzCO2k0oiItoRpCYPkjQPN6B7Lp1YYU99fSxVEhKsl3h7/I0au8l0jImvqohasdj7QX1RlIFMaAISrBchUWhtgJtMxpRE8zF74bqiSLFe4qOkN71g9wNoKjSJ1lhiSWR2paSWihprxUI43sjM7LRILwM1BGO61zjSCdZ0KxbCSapPKs5brDcyXGOwSdaHIv0GpQVm6w+vp188z+yKaAyUGjazCSYzyvvQlEwoH47314SmIyVrHEfmuolsnZa+ZpkmsGEwoSUXWh7YVE2AlBoOZRuLO68iuBP/Kzo5k+t3HKItJybMvn5CC13QXMfXjyzVzZU7WmeIxxzw16Ti/vLnclGzoro2vaJzD/TXICsxvEXhmJjh/ZW4dobX+cuNYdJsoADRmT/+LC5xXWgSDetNfW0430NyrensotUynd0vNjYpYaTeEDgvBGuQ5a/Qs2g4IFcgkmt5HRsHc5/tlLgwYGZGfEDT0EAT2j35IckiPeQVmZQgF3GjXvnEtSxO80zkhA7gd8s2O0g2ZArSRTs9bOicXZ2mpXu6SR9kGWaYoFEGRKavEdlMmD8ctFDUvGgX0Sp9WiDCzXK+lZ22ViQSlhgo6siF9t9XES3BIiiQaLYIHbpnd+s4U0gHLcESMENPnJ229FJT0RIsBZE5jqbC5k509naLEC3BciCzqhzUdNJsEfg/5k8boHl2zOIAAAAASUVORK5CYII="
        />

        {SchoolVideo && (
          <>
            <video ref={videoRef} poster={cardImg} autoplay loop muted>
              <source src={SchoolVideo} type="video/mp4" />
            </video>
            {autoplayVideo ? (
              ""
            ) : (
              <button onClick={handleButtonClick}>
                <img src={isPlaying ? PauseI : PlayI} alt="play" />
              </button>
            )}
          </>
        )}
      </div>

      <div
        className="card-about"
        style={{
          paddingRight: `${headingStyle > "56px" && "5px"}`,
        }}
      >
        <div className="heading">
          <h3 ref={headingRef} className="text-wrapper">
            {cardHeading}
          </h3>

          <span className="coming-soon-TBD">Coming soon &nbsp; &nbsp; &nbsp; &nbsp; TBD</span>
          {/* <span className="card-label">{cardLabel}</span> */}
        </div>
        <div className="para-text">
          <p className="p">{cardText}</p>
          <div className="listen-now">LISTEN NOW</div>
        </div>
      </div>
    </div>
  );
};

export default Index;
